import type { ButtonHTMLAttributes, PropsWithChildren } from "react";

export type ButtonBaseProps = PropsWithChildren<
  ButtonHTMLAttributes<HTMLButtonElement>
>;

export const ButtonBase = ({ type = "button", ...rest }: ButtonBaseProps) => {
  return <button type={type} {...rest} />;
};
